import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';
import { User } from '../../models/user';
import { HOST, USERS_ROUTE, baseHOST } from '../../routes';
import { StorageService } from '../storage-service/storage.service';
import { map, tap } from 'rxjs/operators';
import { AuthService } from '../auth-service/auth.service';

@Injectable()
export class UsersService {

  private readonly baseRoute = HOST + USERS_ROUTE;

  public currentUser$: BehaviorSubject<User> = new BehaviorSubject(null);
  public currentArticleFavorites: BehaviorSubject<any[]> = new BehaviorSubject([]);

  constructor(private http: HttpClient, private storage: StorageService, private authService: AuthService) {
  }

  getUserMe$(): Observable<User> {
    return this.http.get<User>(this.baseRoute + '/me');
  }

  getUserMe(): Observable<boolean> {
    return this.getUserMe$().pipe(map( user => {
      if (user) {
		  if (!user.roles.includes('ROLE_ADMIN') && !user.roles.includes('ROLE_DATA_ADMIN')) return false;
        if (user.company) {
          user.company.image = user.company.image == null ? null : baseHOST + user.company.image;
        }
        this.currentUser$.next(user);
        return true;
      } else {
        return false;
      }
    }));
  }

  setUser(user: User) {
    this.storage.setItem('ownUserId', user.id);
    this.storage.setItem('ownUserFirstname', user.first_name);
    this.storage.setItem('ownUserLastname', user.last_name);
    this.storage.setItem('ownCompanyId', user.company.id);
    this.storage.setObject('ownUserRole', user.roles);
    this.storage.setItem('ownCompanyName', user.company.name);
  }

  public logoutUser() {
    const url = HOST + '/logout';
    return this.http.post(url, {}).pipe(tap( () => {
      this.authService.logout();
    }));
  }
}
